module.exports = __webpack_public_path__ + "img/neo.bef270c0.svg";